<script setup>
import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import SelectableDialogItem from '@/components/widgets/SelectableDialogItem.vue';

const emit = defineEmits(['selected']);
const backendApi = inject('backendApi');
const { t } = useI18n({ useScope: 'global' });

const defaultCustomer = ref([]);
const showRetryButton = ref(false);
const loading = ref(false);

const getCustomersWithoutPoBOX = async () => {
    loading.value = true;
    showRetryButton.value = false;

    backendApi()
        .customers()
        .index(
            {
                limit: 1000,
                page: 1,
                hasPobox: false
            }
        )
        .then(success, fail)
        .finally(() => {
            loading.value = false;
        });

    function success(response) {
        defaultCustomer.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

onMounted(() => {
    getCustomersWithoutPoBOX();
});

const selectableDialogItemRef = ref(null);
const selectableDialogHeaders = [
    { key: 'number', title: t('#'), width: '10%' },
    { key: 'name', title: t('Name'), width: '10%' },
    { key: 'lastname', title: t('Last Name'), align: 'center', width: '10%' },
    {
        key: 'adrdefault.docid',
        title: t('Document Id'),
        align: 'center',
        width: '10%'
    }
];

const open = (object) => {
    selectableDialogItemRef.value.open(object);
};

defineExpose({
    open
});
</script>

<template>
    <SelectableDialogItem
        ref="selectableDialogItemRef"
        :items="defaultCustomer"
        :headers="selectableDialogHeaders"
        :show-retry-button="showRetryButton"
        :loading="loading"
        @selected="(item, object) => emit('selected', item, object)"
        @retry="getCustomersWithoutPoBOX"
        :title="t('Select Customer')"
    ></SelectableDialogItem>
</template>
